import { useOstedhyAuthContext } from './OstedhyAuthContext'
import { useTakiAuthContext } from './TakiAuthContext'
export const useAuthContext = {
  ostedhy: useOstedhyAuthContext,
  taki: useTakiAuthContext,
}
